import React from "react";
import { apiCallPost } from "../fns/util";
import { Alert, Button, Drawer, Input, Space, Spin, Table, Tag } from "antd";
import Profile from "./Profile";

class ProfileList extends React.Component {
  state = {
    dataSource: [],
    columns: [],
    searchString: "",
    isLoading: true,
    isError: false,
    showDrawer: false,
    selectedRecord: null,
  };
  componentDidMount() {
    this.getAllDelegates();
  }
  getAllDelegates = async () => {
    let token = await this.props.context.provideToken();
    try {
      const res = await apiCallPost(
        token,
        "/conference2023/getAllDelegates",
        {}
      );
      this.setState({ results: res.results, isLoading: false }, () => {
        this.transformToTableForm();
      });
    } catch (err) {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    }
  };
  transformToTableForm = () => {
    let results = this.state.results;
    let data = results;
    if (this.state.searchString) {
      data = results.filter((item) => {
        return (
          (item.name || "")
            .toLowerCase()
            .includes(this.state.searchString.toLowerCase()) ||
          (item.email || "")
            .toLowerCase()
            .includes(this.state.searchString.toLowerCase()) ||
          (item.mobile || "")
            .toLowerCase()
            .includes(this.state.searchString.toLowerCase())
        );
      });
    }
    let dataSource = data;
    let columns = [
      {
        title: "Name",
        key: "name",
        dataIndex: "name",
        render: (_, record) => {
          if (record.isAdmin) {
            return <Tag color="orange">{record.name}</Tag>;
          } else {
            return <Tag>{record.name}</Tag>;
          }
        },
        filters: [{ text: "Admins", value: true }],
        onFilter: (value, record) => {
          return record.isAdmin === value;
        },
        // alphabetical sort
        sorter: (a, b) => a.name.localeCompare(b.name),
      },
      { title: "Email", key: "email", dataIndex: "email" },
      { title: "Mobile", key: "mobile", dataIndex: "mobile" },
      {
        title: "Membership",
        key: "membership",
        dataIndex: "membership",
        render: (_, record) => {
          if (record.isOSWBMember) {
            return (
              <Space.Compact direction="vertical">
                <Space>
                  <Tag color="blue">{record.oswbMembershipId}</Tag>
                </Space>
                <Space>
                  <Tag>{record.oswbMembershipPlanName}</Tag>
                </Space>
              </Space.Compact>
            );
          } else if (record.isAccompanyingDelegate) {
            return (
              <Space.Compact direction="vertical">
                <Tag color="orange">Accompanying Delegate</Tag>
              </Space.Compact>
            );
          } else {
            return (
              <Space.Compact direction="vertical">
                <Tag color="red">Not a Member</Tag>
              </Space.Compact>
            );
          }
        },
        filters: [
          {
            text: "Members",
            value: true,
          },
          {
            text: "Non-Members",
            value: false,
          },
        ],
        onFilter: (value, record) => {
          return record.isOSWBMember === value;
        },
      },
      {
        title: "Registration",
        key: "registration",
        dataIndex: "registration",
        render: (_, record) => {
          if (!record.isRegistered) {
            return <Tag color="red">Not Registered</Tag>;
          } else {
            let inclusions = record.lineItems
              .map((each) => each.item)
              .join(", ");
            return (
              <>
                <Tag color="green">Registered</Tag>
                <p className="small_text">{inclusions}</p>
              </>
            );
          }
        },
        filters: [
          {
            text: "Registered",
            value: true,
          },
          {
            text: "Not Registered",
            value: false,
          },
        ],
        onFilter: (value, record) => {
          return record.isRegistered === value;
        },
      },
    ];
    this.setState({
      dataSource,
      columns,
    });
  };
  renderDrawer = () => {
    if (!this.state.selectedRecord) return null;
    return (
      <Drawer
        size="large"
        title={this.state.selectedRecord.name}
        open={this.state.showDrawer}
        onClose={() => {
          this.setState({
            showDrawer: false,
            selectedRecord: null,
          });
        }}
      >
        <Profile
          mode="EDIT"
          loggedInUser={this.props.loggedInUser}
          preloadedData={this.state.selectedRecord}
          isRegistering={false}
          isAdmin={this.props.isAdmin}
          context={this.props.context}
          onDelegateUpdate={(delegate) => {
            this.setState({
              selectedRecord: delegate,
            });
          }}
        />
      </Drawer>
    );
  };
  render() {
    // Check if data is still loading
    if (this.state.isLoading) {
      return (
        <div>
          <Spin />
        </div>
      );
    }
    // Check if there was an error loading the data
    if (this.state.isError) {
      return (
        <Alert
          message="Error"
          description="An error occurred while loading the data."
          type="error"
          showIcon
        />
      );
    }

    return (
      <div>
        {this.renderDrawer()}
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button type="text" disabled>
            Search
          </Button>
          <Input
            value={this.state.searchString}
            onChange={(e) =>
              this.setState(
                {
                  searchString: e.target.value,
                },
                () => {
                  this.transformToTableForm();
                }
              )
            }
          ></Input>
        </Space>
        <Table
          onRow={(record) => {
            return {
              onClick: () => {
                this.setState({
                  showDrawer: true,
                  selectedRecord: record,
                });
                //   this.props.onSelect(record);
              },
            };
          }}
          dataSource={this.state.dataSource}
          columns={this.state.columns}
        />
      </div>
    );
  }
}

export default ProfileList;
